module.exports = "/static/assets/642fb2f987bf8b54f176af13746c04cb.png";